if (!window.Eurus.loadedScript.has('gift-with-purchase.js')) {
  window.Eurus.loadedScript.add('gift-with-purchase.js');

  (function () {
    var gwpProcessing = false;
    var config = window.Eurus.gwp;
    if (!config) return;

    function getSections() {
      if (typeof Alpine !== 'undefined' && Alpine.store('xCartHelper')) {
        return Alpine.store('xCartHelper').getSectionsToRender().map(function (s) { return s.id; });
      }
      return ['cart-drawer', 'cart-icon-bubble', 'mobile-cart-icon-bubble'];
    }

    function updateSections(response) {
      if (!response || !response.sections) return;
      if (typeof Alpine === 'undefined' || !Alpine.store('xCartHelper')) return;
      Alpine.store('xCartHelper').getSectionsToRender().forEach(function (section) {
        var el = document.querySelector(section.selector);
        if (el && response.sections[section.id]) {
          el.innerHTML = getSectionInnerHTML(response.sections[section.id], section.selector);
        }
      });
      var bubble = document.querySelector('#cart-icon-bubble span');
      if (bubble) {
        Alpine.store('xCartHelper').currentItemCount = parseInt(bubble.innerHTML);
      }
    }

    function evaluateGwp() {
      if (gwpProcessing) return;

      fetch(Shopify.routes.root + 'cart.js', {
        headers: { 'Content-Type': 'application/json' }
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (gwpProcessing) return;

          var hasQualifier = false;
          var giftItem = null;
          var hasAnySealant = false;

          cart.items.forEach(function (item) {
            if (config.qualifyingProductIds.indexOf(item.product_id) !== -1) {
              hasQualifier = true;
            }
            if (item.variant_id === config.giftVariantId) {
              hasAnySealant = true;
            }
            if (item.properties && item.properties._gwp === 'true') {
              giftItem = item;
            }
          });

          if (hasQualifier && !giftItem && !hasAnySealant) {
            addGift();
          } else if (!hasQualifier && giftItem) {
            removeGift(giftItem.key);
          } else if (giftItem && giftItem.quantity > 1) {
            resetGiftQty(giftItem.key);
          }
        });
    }

    function addGift() {
      gwpProcessing = true;

      fetch(Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: config.giftVariantId, quantity: 1, properties: { _gwp: 'true' } }],
          sections: getSections()
        })
      })
        .then(function (r) { return r.json(); })
        .then(function (response) {
          updateSections(response);
          document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
        })
        .catch(function (e) { console.error('GWP add error:', e); })
        .finally(function () { gwpProcessing = false; });
    }

    function removeGift(itemKey) {
      gwpProcessing = true;

      fetch(Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: itemKey,
          quantity: 0,
          sections: getSections()
        })
      })
        .then(function (r) { return r.json(); })
        .then(function (response) {
          updateSections(response);
          document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
        })
        .catch(function (e) { console.error('GWP remove error:', e); })
        .finally(function () { gwpProcessing = false; });
    }

    function resetGiftQty(itemKey) {
      gwpProcessing = true;

      fetch(Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: itemKey,
          quantity: 1,
          sections: getSections()
        })
      })
        .then(function (r) { return r.json(); })
        .then(function (response) {
          updateSections(response);
        })
        .catch(function (e) { console.error('GWP qty reset error:', e); })
        .finally(function () { gwpProcessing = false; });
    }

    document.addEventListener('eurus:cart:items-changed', function () {
      if (gwpProcessing) return;
      setTimeout(function () {
        if (!gwpProcessing) evaluateGwp();
      }, 300);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', evaluateGwp);
    } else {
      evaluateGwp();
    }
  })();
}
